<script>
  /** @type {"green" | "yellow" | "red" | "black" | "grey" | "light-grey" | "light-red" | string} */
  export let color = "green";

  /** @type {string} */
  export let text = "";

  /** @type {boolean} */
  export let small = false;

  /** @type {boolean} */
  export let bold = false;

  /** @type {boolean} */
  export let border = false;

  /** @type {string} */
  export let textColor = "";
</script>

<div
  class:bx--badge="{true}"
  class:bx--badge--color="{true}"
  class:bx--badge--border="{border}"
  class:bx--badge--green="{color === 'green'}"
  class:bx--badge--yellow="{color === 'yellow'}"
  class:bx--badge--red="{color === 'red'}"
  class:bx--badge--black="{color === 'black'}"
  class:bx--badge--grey="{color === 'grey'}"
  class:bx--badge--light-grey="{color === 'light-grey'}"
  class:bx--badge--light-red="{color === 'light-red'}"
  class:bx--badge--custom="{color !== 'green' &&
    color !== 'yellow' &&
    color !== 'red' &&
    color !== 'black' &&
    color !== 'grey' &&
    color !== 'light-grey' &&
    color !== 'light-red'}"
>
  <span class:small="{small}" class:bold="{bold}" style="color: {textColor}"
    >{text}</span
  >
</div>

<style>
  .bx--badge.bx--badge--color {
    display: inline-flex;
    height: 1.1875rem;
    padding: 0.75rem 0.5rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.29688rem;
    flex-shrink: 0;
    border-radius: 1.60313rem;
    color: var(--pax-black, #1c1c20);
  }

  .bx--badge--color span {
    color: currentColor;
  }

  .bx--badge--color span.small {
    font-size: 0.75rem;
    line-height: 0.75rem;
  }

  .bx--badge--color span.bold {
    font-weight: bold;
  }

  .bx--badge--color.bx--badge--border {
    border: 1px solid #d9d9d9;
  }

  .bx--badge--color.bx--badge--border.bx--badge--green {
    border-color: #6bb56f;
  }
  .bx--badge--color.bx--badge--green {
    background: #8ef095;
  }

  .bx--badge--color.bx--badge--border.bx--badge--yellow {
    border-color: #b8bd70;
  }

  .bx--badge--color.bx--badge--yellow {
    background: #e9f08e;
  }

  .bx--badge--color.bx--badge--border.bx--badge--red, .bx--badge--color.bx--badge--border.bx--badge--light-red  {
    border-color: #a66162;
  }

  .bx--badge--color.bx--badge--red {
    background: #f08e90;
  }

  .bx--badge--color.bx--badge--grey {
    background: #f2f2f2;
  }

  .bx--badge--color.bx--badge--light-grey {
    background: #f9fbff;
  }

  .bx--badge--color.bx--badge--light-red {
    background: #e6a7ad;
  }

  .bx--badge--color.bx--badge--black {
    background: var(--pax-black);
    color: var(--pax-white);
  }

  .bx--badge--color.bx--badge--custom {
    background: var(--custom-color);
  }
</style>
